import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { PartnerCTA } from '../components/PartnerCTA';
export function DefenceProcurementPage() {
  const contentBlocks = [{
    heading: 'Reliable manufacturing for defence procurement',
    image: 'https://cdn.magicpatterns.com/uploads/cgpFBudHGosue3cH628Vuv/45161938-scaled.jpg',
    imageAlt: 'Soldier in camouflage gear with rifle in the field',
    paragraphs: ['Defence procurement has long been a core part of our business. We have been providing combat ready equipment to armed forces around the world since our incorporation in 2005.', 'Building on a legacy of bespoke manufacturing, helping our clients with their defence projects, our defence division, Chiltern Defence, helps our clients from concept to delivery, all the way from specification analysis, through the entire manufacturing process to the final shipped product.']
  }, {
    heading: 'What products do we manufacture?',
    image: 'https://cdn.magicpatterns.com/uploads/mGyijyZGn7MPY4QhKeHATa/Clothing-1.jpg',
    imageAlt: 'Military camouflage uniform with UK flag patch',
    paragraphs: ['As specialists in textile manufacturing, we cover a wide range of products. From uniforms, to load carriage, to ballistic protection and camouflage netting solutions, no matter your requirement Chiltern Defence are ready to help our partners.', 'In addition to this, we also produce a specialist range of equipment for the police and prisons industries including public order equipment, much of which is transferrable to the defence industry.'],
    cta: {
      label: 'Learn More',
      to: '/products'
    }
  }, {
    heading: 'Our manufacturing facilities',
    image: 'https://cdn.magicpatterns.com/uploads/cJmcybkRNgCksh1S8QiVuQ/What_we_do.jpg',
    imageAlt: 'Chiltern Global manufacturing and operational overview',
    paragraphs: ['Chiltern Global is based in Chesham, with its UK based assembly line, this is where we assemble much of our public order equipment, develop samples and make adjustments to many of our specialist products. In addition to this, we have built up a network of suppliers throughout Asia and Europe over a period of 20+ years which helps up put together manufacturing solutions fit to your requirements.'],
    cta: {
      label: 'Learn More',
      to: '/manufacturing/processes'
    }
  }];
  const partners = [{
    name: 'Make UK Defence',
    logo: 'https://cdn.magicpatterns.com/uploads/cfP4ywzNizUEjpNhgJmApG/Make_UK_Defence_Logo_Col_72dpi_002_002.png',
    url: 'https://www.makeuk.org/about/make-uk-defence'
  }, {
    name: 'Armed Forces Covenant',
    logo: 'https://cdn.magicpatterns.com/uploads/gUUdKgzQzHWsQRqAAQwxq7/AFC_POSITIVE_RGB.png'
  }, {
    name: 'Cyber Essentials Plus',
    logo: 'https://cdn.magicpatterns.com/uploads/13vUPeUkJ8i5oDWP9yZJcD/cyberessentials_certification-mark-plus_colour.png'
  }, {
    name: 'ISO 9001:2015',
    logo: 'https://cdn.magicpatterns.com/uploads/du9xSAnpmrfhYGmqcMzu2B/UKAS_9001.png'
  }, {
    name: 'ISO 14001:2015',
    logo: 'https://cdn.magicpatterns.com/uploads/c6RGX87GDb7n4CWSe5fWPD/ISO_140001.png'
  }, {
    name: 'JOSCAR',
    logo: 'https://cdn.magicpatterns.com/uploads/byihqp9gceccmuWddiSZfV/Joscar.png'
  }, {
    name: 'Disability Confident',
    logo: 'https://cdn.magicpatterns.com/uploads/8XG2XHqH34Hii3s1MmkT7X/dc_badge1.png'
  }, {
    name: 'ADS',
    logo: 'https://cdn.magicpatterns.com/uploads/wkQpRYtwzEksVJ7NSu1naU/ADS.png',
    url: 'https://www.adsgroup.org.uk'
  }, {
    name: 'Watford & West Herts Chamber of Commerce',
    logo: 'https://cdn.magicpatterns.com/uploads/87KVCewgCkuKpmjwMFudRC/watford_logo.png'
  }];
  return <>
      {/* HERO */}
      <PageHero label="Manufacturing" title="Defence Procurement Guide" subtitle="Browse our comprehensive defence procurement catalogue with detailed product specifications and pricing information." backgroundImage="https://cdn.magicpatterns.com/uploads/cgpFBudHGosue3cH628Vuv/45161938-scaled.jpg" data-id="element-742" />

      {/* BREADCRUMBS */}
      <Breadcrumbs items={[{
      label: 'Manufacturing',
      to: '/manufacturing'
    }, {
      label: 'Defence Procurement'
    }]} data-id="element-743" />

      {/* CONTENT BLOCKS */}
      <section className="bg-white py-24" data-id="element-744">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-745">
          <div className="space-y-24" data-id="element-746">
            {contentBlocks.map((block, index) => {
            const imageLeft = index % 2 !== 0;
            return <div key={index} className={`flex flex-col ${imageLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-16 items-center`} data-id="element-747">
                  {/* Image */}
                  <div className="w-full lg:w-1/2 aspect-[4/3] overflow-hidden rounded-sm bg-slate-100" data-id="element-748">
                    <img src={block.image} alt={block.imageAlt} className="w-full h-full object-cover" data-id="element-749" />
                  </div>

                  {/* Text */}
                  <div className="w-full lg:w-1/2" data-id="element-750">
                    <h3 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-751">
                      {block.heading}
                    </h3>
                    <div className="space-y-4" data-id="element-752">
                      {block.paragraphs.map((p, i) => <p key={i} className="text-lg text-steel-600 leading-relaxed" data-id="element-753">
                          {p}
                        </p>)}
                    </div>
                    {block.cta && <div className="mt-8" data-id="element-754">
                        <Link to={block.cta.to} className="inline-flex items-center justify-center px-8 py-4 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors" data-id="element-755">
                          {block.cta.label}
                        </Link>
                      </div>}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* FIND OUT MORE CTA */}

      {/* PARTNER LOGOS STRIP */}
      <section className="bg-white py-16 border-t border-steel-200" data-id="element-756">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-757">
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16" data-id="element-758">
            {partners.map((partner, index) => {
            const img = <img src={partner.logo} alt={partner.name} className="w-full h-auto object-contain max-h-16" data-id="element-759" />;
            return partner.url ? <a key={index} href={partner.url} target="_blank" rel="noopener noreferrer" className="block w-28 md:w-36 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-760">
                  {img}
                </a> : <div key={index} className="block w-28 md:w-36 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-761">
                  {img}
                </div>;
          })}
          </div>
        </div>
      </section>

      {/* PARTNER CTA */}
      <PartnerCTA data-id="element-762" />
    </>;
}